// extracted by mini-css-extract-plugin
module.exports = {"page":"_16023","rule":"_10996","container":"_2373","title":"_3315","content":"_3060"};